import axios from '../http'

function query(data) {
    return axios.post('/sys/emailTemplate/query', data);
}

function get(id) {
    return axios.get('/sys/emailTemplate/get?id=' + id);
}

function add(data) {
    return axios.post('/sys/emailTemplate/add', data);
}

function update(data) {
    return axios.post('/sys/emailTemplate/update', data);
}

function del(id) {
    return axios.post('/sys/emailTemplate/del?id=' + id);
}

export default {
    query,
    get,
    add,
    update,
    del
}